// extracted by mini-css-extract-plugin
module.exports = {"simulations":"Simulations_simulations__fU1S_"};